import querystring from '../../../../node_modules/querystring';
/**
 * Model logic for facets
 * @see js/public/faceted-media.js
 */

export default class FacetsModel {

    constructor(singleFacets, multiFacets, rangeFacets) {
        this._params = querystring.parse(window.location.search.substr(1)) || {};
        this._singleFacets = singleFacets; // single key-value pair facets
        this._multiFacets = multiFacets;  // multiple values for each name facets
        this._rangeFacets = rangeFacets;
    }

    /**
     * Updates the stored parameters
     */
    beginTransaction() {
        this._params = querystring.parse(window.location.search.substr(1)) || {};
    }

    /**
     * Reloads the page with the new query string
     */
    endTransaction() {
        if (!!window.OverDrive.titleCollection && !!window.OverDrive.titleCollection.maxItems && window.OverDrive.titleCollection.maxItems < 2147483647 && !!window.OverDrive.titleCollection.breakpoint) {
            this._params.breakpoint = window.OverDrive.titleCollection.breakpoint;
        }
        let qs = querystring.stringify(this._params);

        qs = qs.length > 0 ? `?${qs}` : qs;

        window.location.search = qs;
    }

    /**
     * Sets a facet with a name/value pair
     * @param name {string}
     * @param value {string}
     */
    setFacet(name, value) {
        if (this._multiFacets.includes(name)) {
            if (!this._params[name]) {
                this._params[name] = [value];
            }
            else if (!Array.isArray(this._params[name])) { // if it was there only once it is a string
                this._params[name] = [this._params[name], value];
            }
            else {
                this._params[name].push(value);
            }
        }
        else if (this._singleFacets.includes(name)) {
            this._params[name] = value;
        }
        else if (this._rangeFacets.includes(name)) {
            const min = name + 'Min';
            const max = name + 'Max';
            this._params[min] = value;
            this._params[max] = value;
        }
    }

    /**
     * Unsets a facet with a name/value pair
     * @param {string} name the name of the facet
     * @param {string} value (optional) if undefined all elements with the name will be deleted
     */
    unsetFacet(name, value) {
        if (this._rangeFacets.includes(name)) {
            const min = name + 'Min';
            const max = name + 'Max';
            delete this._params[min];
            delete this._params[max];
        }
        else if (!value || this._singleFacets.includes(name)) {
            delete this._params[name];
        }
        else if (this._multiFacets.includes(name)) {
            if (this._params[name] && Array.isArray(this._params[name])) {
                this._params[name].splice(this._params[name].indexOf(value));
                if (this._params[name].length === 0) {
                    delete this._params[name];
                }
            }
            else {
                delete this._params[name];
            }
        }
    }

    /**
     * Deletes all facets
     */
    unsetAllFacets() {
        _.each(this._singleFacets, (facet) => {
            var name = facet;
            this.unsetFacet(name);
        });
        _.each(this._multiFacets, (facet) => {
            var name = facet;
            this.unsetFacet(name);
        });
        _.each(this._rangeFacets, (facet) => {
            var name = facet;
            this.unsetFacet(name);
        });
    }

    /**
     * Deletes a parameter that is not a facet
     * @param name {string}
     */
    deleteOtherParam(name) {
        if (!this._singleFacets.includes(name) && !this._multiFacets.includes(name)) {
            delete this._params[name];
        }
    }

    /**
     * Sets a parameter that is not a facet
     * @param {string} name the name of the facet to set
     * @param {string} value the facet's value
     */
    setOtherParam(name, value) {
        if (!this._singleFacets.includes(name) && !this._multiFacets.includes(name)) {
            this._params[name] = value;
        }
    }

    /**
     * Checks for a parameter that is not a facet
     * @param {string} name  the name of the parameter
     * @returns {boolean} true if the parameter exists and it is not a facet
     */
    hasOtherParam(name) {
        if (!this._singleFacets.includes(name) && !this._multiFacets.includes(name)) {
            return !!this._params[name];
        }
        return false;
    }

    /**
     * Counts the facets for use by the clear all button to know if there are lozenges
     * that are clearable
     * @returns {number} the number of facets
     */
    countFacets() {
        let count = 0;
        for (let facet of this._singleFacets) {
            if (this._params[facet]) {
                count++;
            }
        }
        for (let facet of this._rangeFacets) {
            if (this._params[facet + 'Min'] || this._params[facet + 'Max']) {
                count++;
            }
        }
        for (let facet of this._multiFacets) {
            if (this._params[facet]) {
                if (Array.isArray(this._params[facet])) {
                    count += this._params[facet].length;
                }
                else {
                    count++;
                }
            }
        }
        return count;
    }
}

